import React from "react";
import styles from "./Colaborador08.module.css";
import ImgColaborador from "../../images/Julia Galendi.jpg";
import IconLattes from "../../images/iconLattes.png";
import ButtonVoltar from "../../components/ButtonVoltar/ButtonVoltar";
import IconVoltar from "../../images/iconBtn1.svg";
import { useNavigate } from "react-router-dom";

const Colaborador07 = ({ lang }) => {
  const navigate = useNavigate();

  const handleOnClickEquipe = () => {
    return navigate("/equipe");
  };

  return (
    <main className={styles.mainColaboradorCEO}>
      <section className={styles.colaboradorContent}>
        <div className={styles.colaboradorDivContent}>
          <div id={styles.colaboradorImg}>
            <img
              id={styles.imgId}
              src={ImgColaborador}
              alt="Dra. Julia Galendi"
            />
          </div>

          <div className={styles.colaboradorInfos}>
            <h1 id={styles.colaboradorTitle}>Dra. Julia Galendi</h1>

            {lang === "BRA" ? (
              <ul id={styles.colaboradorList}>
                <li id={styles.colaboradorDescription}>
                  • Médica, Mestre em Pesquisa Clínica pela Faculdade de
                  Medicina de Botucatu (UNESP), Doutora em Ciências da Saúde
                  pelo Instituto de Economia da Saúde e Epidemiologia Clínica da
                  Universidade de Colônia, e atualmente pesquisadora e
                  professora do programa de Pesquisa Clínica da Faculdade de
                  Medicina de Botucatu.
                </li>
                <li id={styles.colaboradorDescription}>
                  • Possui ampla experiência em estudos de Avaliação de
                  Tecnologias em Saúde (ATS) no contexto do Sistema Único de
                  Saúde (SUS) e saúde suplementar, como na elaboração de
                  Protocolos Clínicos e Diretrizes Terapêuticas (PCDTs) junto ao
                  Ministério da Saúde e como representante suplente dos NATS na
                  CONITEC (2023-2024).
                </li>
                <li id={styles.colaboradorDescription}>
                  • Tem expertise na elaboração de revisões sistemáticas e na
                  realização de estudos de custo-efetividade e de impacto
                  orçamentário com diversas publicações nacionais e
                  internacionais.
                </li>
              </ul>
            ) : (
              <ul id={styles.colaboradorList}>
                <li id={styles.colaboradorDescription}>
                  • Médica, Mestre em Pesquisa Clínica pela Faculdade de
                  Medicina de Botucatu (UNESP), Doutora em Ciências da Saúde
                  pelo Instituto de Economia da Saúde e Epidemiologia Clínica da
                  Universidade de Colônia, e atualmente pesquisadora e
                  professora do programa de Pesquisa Clínica da Faculdade de
                  Medicina de Botucatu.
                </li>
                <li id={styles.colaboradorDescription}>
                  • Possui ampla experiência em estudos de Avaliação de
                  Tecnologias em Saúde (ATS) no contexto do Sistema Único de
                  Saúde (SUS) e saúde suplementar, como na elaboração de
                  Protocolos Clínicos e Diretrizes Terapêuticas (PCDTs) junto ao
                  Ministério da Saúde e como representante suplente dos NATS na
                  CONITEC (2023-2024).
                </li>
                <li id={styles.colaboradorDescription}>
                  • Tem expertise na elaboração de revisões sistemáticas e na
                  realização de estudos de custo-efetividade e de impacto
                  orçamentário com diversas publicações nacionais e
                  internacionais.
                </li>
              </ul>
            )}

            <a
              href="http://lattes.cnpq.br/4952937785289219"
              target="_blank"
              rel="noreferrer"
            >
              <button id={styles.colaboradorButton}>
                <span>Lattes</span>
                <img src={IconLattes} alt="" />
              </button>
            </a>
          </div>
        </div>
        <ButtonVoltar
          text={lang === "BRA" ? "VOLTAR PARA EQUIPE" : "BACK TO TEAM"}
          icon={IconVoltar}
          onClick={() => handleOnClickEquipe()}
          btnStyle={"Light"}
        />
      </section>
    </main>
  );
};

export default Colaborador07;
